import SeoLandingLayout from "../../components/SeoLandingLayout";

export default function BridalJewelleryMeerut() {
  return (
    <SeoLandingLayout
      testId="bridal-meerut-page"
      path="/bridal-jewellery-meerut"
      seoTitle="Bridal Jewellery in Meerut | Wedding Gold & Diamond Sets | Ramesh Kapoor & Sons"
      seoDescription="Bridal and wedding jewellery in Meerut — gold and diamond bridal sets, mangalsutras and family selections, with pre-planned showroom appointments at Abu Plaza, Meerut."
      crumbLabel="Bridal Jewellery Meerut"
      eyebrow="Weddings"
      h1={<>Bridal &amp; Wedding Jewellery in <span className="italic text-[#C5A059]">Meerut</span></>}
      intro={[
        "A wedding purchase in Meerut is rarely a single piece. It is a set built over several visits — across budgets, occasions and generations of the family. Ramesh Kapoor & Sons Jewellers Pvt. Ltd. has served that process from Meerut's jewellery market for five decades, first as a wholesale house and today also at our Abu Plaza retail showroom.",
        "This page explains how families plan wedding jewellery with us — and how an appointment turns a crowded decision into a calm one.",
      ]}
      hero={{ src: "/images/showroom.jpg", alt: "The Abu Plaza showroom in Meerut prepared for a bridal jewellery consultation" }}
      sections={[
        {
          id: "the-wedding-set",
          eyebrow: "The Set",
          title: "Building the Wedding Set",
          paragraphs: [
            "A complete wedding selection typically moves through bridal gold sets, diamond sets, the mangalsutra, bangles and the accompanying pieces a wedding household expects — for the bride, and often for family members on both sides. Our range covers traditional bridal work and contemporary interpretations of it.",
            "Because wholesale is our principal business, the showroom's bridal depth comes from the same stock discipline jewellers rely on — variety across weights and budgets, with designs developed against what wedding seasons actually ask for.",
          ],
        },
        {
          id: "the-appointment",
          eyebrow: "The Appointment",
          title: "A Selection Prepared Before You Arrive",
          paragraphs: [
            "Wedding jewellery rewards unhurried comparison. When you book a showroom appointment, tell us the occasion, the budget, the categories and the preferred weight range — our team prepares a selection in advance, so your time at the counter is spent choosing, not searching.",
            "Families often visit more than once, and that is expected: decisions this size should be made at your pace, with every price component — rate, weight, purity, making charges, taxes — disclosed each time.",
          ],
        },
        {
          id: "gold-or-diamond",
          eyebrow: "Choosing",
          title: "Gold, Diamond, or Both",
          paragraphs: [
            "Most Meerut weddings draw on both metals: gold for tradition and ceremony, diamonds for the pieces meant to be worn long after. Our gold jewellery and diamond jewellery pages go deeper into each; at the showroom, the two are planned together so the full selection sits coherently across the wedding.",
          ],
        },
        {
          id: "beyond-the-wedding",
          eyebrow: "After",
          title: "Beyond the Wedding Day",
          paragraphs: [
            "The same showroom serves engagement, anniversary, festival and gifting purchases — including gold and silver coins for auspicious occasions. Families who begin with a wedding often return for everything after; that continuity is the point of a family jewellery house.",
          ],
        },
      ]}
      faqs={[
        { q: "Where can I buy bridal jewellery in Meerut?", a: "At our Abu Plaza retail showroom in Meerut, which presents bridal gold and diamond sets, mangalsutras, bangles and accompanying wedding pieces. Booking an appointment lets us prepare a selection in advance." },
        { q: "Can we pre-select bridal jewellery within a budget?", a: "Yes. Share your budget, occasion, preferred categories and weight range when booking, and the prepared selection will reflect them." },
        { q: "Do you have both traditional and contemporary bridal designs?", a: "Yes — the bridal range covers traditional wedding styles and contemporary interpretations, across gold and diamond." },
        { q: "When should we book an appointment before a wedding?", a: "As early as is comfortable. Wedding selections often take more than one visit, and early planning gives you the widest choice of designs and weights." },
        { q: "Do you also have mangalsutras and coins for the ceremony?", a: "Yes. Mangalsutras are a dedicated category, and gold and silver coins are available for auspicious occasions and gifting." },
      ]}
      cta={{
        title: <>Plan the wedding selection <span className="italic text-[#C5A059]">calmly.</span></>,
        buttons: [
          { to: "/jewellery/appointment", label: "Book a Showroom Appointment", primary: true },
          { to: "/jewellery/category/bridal-jewellery", label: "Browse Bridal Jewellery" },
          { to: "/jewellery/rates", label: "Today's Gold Rate" },
        ],
      }}
      siblings={[
        { to: "/gold-jewellery-meerut", label: "Gold jewellery in Meerut" },
        { to: "/diamond-jewellery-meerut", label: "Diamond jewellery in Meerut" },
        { to: "/jewellery-meerut", label: "Jewellery in Meerut — overview" },
      ]}
    />
  );
}
